(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["myrevora-before-after"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('myrevora-before-after')) {
    customElements.define('myrevora-before-after', class extends HTMLElement {
      connectedCallback() {
        this.controller?.abort();
        this.controller = new AbortController();
        this.addEventListener('input', (event) => {
          if (event.target.matches('.myrevora-compare__range')) {
            this.style.setProperty('--compare-position', `${event.target.valueAsNumber}%`);
          }
        }, { signal: this.controller.signal });
        this.setAttribute('data-ready', '');
      }
      disconnectedCallback() {
        this.controller?.abort();
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["myrevora-reviews"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('myrevora-reviews')) {
    customElements.define('myrevora-reviews', class extends HTMLElement {
      connectedCallback() {
        this.setupFrame = requestAnimationFrame(() => this.initialize());
      }

      initialize() {
        this.track = this.querySelector('[data-review-track]');
        if (!this.track) return;
        this.cards = [...this.querySelectorAll('[data-review-card]')];
        this.navigation = this.querySelector('[data-review-navigation]');
        this.previous = this.querySelector('[data-review-previous]');
        this.next = this.querySelector('[data-review-next]');
        this.events = new AbortController();
        const signal = this.events.signal;
        this.previous.addEventListener('click', () => this.move(-1), { signal });
        this.next.addEventListener('click', () => this.move(1), { signal });
        this.track.addEventListener('scroll', () => this.update(), { passive: true, signal });
        this.addEventListener('shopify:block:select', (event) => {
          const card = event.target.closest('[data-review-card]');
          if (card && this.contains(card)) this.reveal(card);
        }, { signal });
        this.resizeObserver = new ResizeObserver(() => this.update());
        this.resizeObserver.observe(this.track);
        this.update();
      }

      disconnectedCallback() {
        cancelAnimationFrame(this.setupFrame);
        this.events?.abort();
        this.resizeObserver?.disconnect();
      }

      update() {
        this.toggleAttribute('data-rtl', getComputedStyle(this.track).direction === 'rtl');
        const viewport = this.track.getBoundingClientRect();
        const fullyVisible = (card) => {
          const rect = card.getBoundingClientRect();
          return rect.left >= viewport.left - 2 && rect.right <= viewport.right + 2;
        };
        this.navigation.hidden = this.track.scrollWidth <= this.track.clientWidth + 2;
        this.previous.disabled = fullyVisible(this.cards[0]);
        this.next.disabled = fullyVisible(this.cards[this.cards.length - 1]);
      }

      move(step) {
        const rtl = getComputedStyle(this.track).direction === 'rtl';
        const edge = rtl ? 'right' : 'left';
        const start = this.track.getBoundingClientRect()[edge];
        let closest = 0;
        let distance = Infinity;
        this.cards.forEach((card, index) => {
          const delta = Math.abs(card.getBoundingClientRect()[edge] - start);
          if (delta < distance) {
            closest = index;
            distance = delta;
          }
        });
        const index = Math.max(0, Math.min(this.cards.length - 1, closest + step));
        this.reveal(this.cards[index]);
      }

      reveal(card) {
        card.scrollIntoView({
          inline: 'start',
          block: 'nearest',
          behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'
        });
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["myrevora-scrolling-announcement"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('myrevora-scrolling-announcement')) {
    customElements.define('myrevora-scrolling-announcement', class extends HTMLElement {
      connectedCallback() {
        this.setupFrame = requestAnimationFrame(() => this.initialize());
      }
      initialize() {
        if (!this.isConnected) return;
        this.viewport = this.querySelector('.myrevora-ticker__viewport');
        this.track = this.querySelector('.myrevora-ticker__track');
        this.group = this.querySelector('.myrevora-ticker__group');
        if (!this.group) return;
        this.originals = [...this.group.children].filter(item => !item.hasAttribute('aria-hidden'));
        this.motion = matchMedia('(prefers-reduced-motion: reduce)');
        this.refresh = () => {
          cancelAnimationFrame(this.frame);
          this.frame = requestAnimationFrame(() => this.fill());
        };
        this.observer = new ResizeObserver(this.refresh);
        this.observer.observe(this.viewport);
        this.motion.addEventListener('change', this.refresh);
        document.fonts.ready.then(() => { if (this.isConnected) this.refresh(); });
        this.refresh();
      }
      fill() {
        if (!this.isConnected) return;
        this.group.replaceChildren(...this.originals);
        this.track.querySelectorAll('.myrevora-ticker__group[aria-hidden]').forEach(group => group.remove());
        this.setAttribute('data-ready', '');
        if (this.motion.matches || this.classList.contains('myrevora-ticker--static')) return;
        const sequenceWidth = this.group.getBoundingClientRect().width;
        if (!sequenceWidth) return;
        const repetitions = Math.ceil(this.viewport.clientWidth / sequenceWidth) + 1;
        for (let repeat = 1; repeat < repetitions; repeat++) {
          this.originals.forEach(item => {
            const clone = item.cloneNode(true);
            clone.removeAttribute('data-shopify-editor-block');
            clone.setAttribute('aria-hidden', 'true');
            this.group.append(clone);
          });
        }
        const copy = this.group.cloneNode(true);
        copy.setAttribute('aria-hidden', 'true');
        copy.querySelectorAll('[data-shopify-editor-block]').forEach(item => item.removeAttribute('data-shopify-editor-block'));
        this.track.append(copy);
      }
      disconnectedCallback() {
        cancelAnimationFrame(this.setupFrame);
        cancelAnimationFrame(this.frame);
        this.observer?.disconnect();
        this.motion?.removeEventListener('change', this.refresh);
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
